/** The full yeast collection, assembled from the per-lab files. */

import type { Yeast } from '../../schema/yeast';
import { aebYeasts } from './aeb';
import { berkeleyYeasts } from './berkeley-yeast';
import { bootlegBiologyYeasts } from './bootleg-biology';
import { brewlabYeasts } from './brewlab';
import { bsiYeasts } from './bsi';
import { cellarScienceYeasts } from './cellarscience';
import { crossMyLoofYeasts } from './crossmyloof';
import { dryYeasts } from './dry';
import { escarpmentYeasts } from './escarpment';
import { imperialYeasts } from './imperial';
import { inlandIslandYeasts } from './inland-island';
import { jasperYeasts } from './jasper';
import { kveikYeasteryYeasts } from './kveik-yeastery';
import { lalvinYeasts } from './lalvin';
import { muntonsYeasts } from './muntons';
import { omegaYeasts } from './omega';
import { redStarYeasts } from './red-star';
import { rvaYeasts } from './rva';
import { whcYeasts } from './whc-lab';
import { whiteLabsYeasts } from './white-labs';
import { wyeastYeasts } from './wyeast';
import { yeastBayYeasts } from './yeast-bay';

export { aebYeasts } from './aeb';
export { berkeleyYeasts } from './berkeley-yeast';
export { bootlegBiologyYeasts } from './bootleg-biology';
export { brewlabYeasts } from './brewlab';
export { bsiYeasts } from './bsi';
export { cellarScienceYeasts } from './cellarscience';
export { crossMyLoofYeasts } from './crossmyloof';
export { dryYeasts } from './dry';
export { escarpmentYeasts } from './escarpment';
export { imperialYeasts } from './imperial';
export { inlandIslandYeasts } from './inland-island';
export { jasperYeasts } from './jasper';
export { kveikYeasteryYeasts } from './kveik-yeastery';
export { lalvinYeasts } from './lalvin';
export { muntonsYeasts } from './muntons';
export { omegaYeasts } from './omega';
export { redStarYeasts } from './red-star';
export { rvaYeasts } from './rva';
export { whcYeasts } from './whc-lab';
export { whiteLabsYeasts } from './white-labs';
export { wyeastYeasts } from './wyeast';
export { yeastBayYeasts } from './yeast-bay';

/** Every yeast in the catalog. */
export const yeasts: readonly Yeast[] = [
  ...dryYeasts,
  ...cellarScienceYeasts,
  ...wyeastYeasts,
  ...whiteLabsYeasts,
  ...omegaYeasts,
  ...imperialYeasts,
  ...escarpmentYeasts,
  ...bootlegBiologyYeasts,
  ...kveikYeasteryYeasts,
  ...yeastBayYeasts,
  ...rvaYeasts,
  ...jasperYeasts,
  ...lalvinYeasts,
  ...redStarYeasts,
  ...berkeleyYeasts,
  ...whcYeasts,
  ...aebYeasts,
  ...bsiYeasts,
  ...inlandIslandYeasts,
  ...crossMyLoofYeasts,
  ...brewlabYeasts,
  ...muntonsYeasts,
];
